export default __webpack_public_path__ + "static/media/thumbnail-mobile-04.e4c6ec4a.png";